// import jQuery from 'CommonScripts/jquery-1.10.2';
(function (window, document, $) {
    
    $(document).ready(function () {            
        var imagesLoaded = require('imagesloaded');
        imagesLoaded.makeJQueryPlugin( $ );
        /* Loop through all spots and align the image, title, text and button parts */
       // $.components.registerComponent('main > section', function ($root) {
            var $root = document.querySelectorAll('main > section');
            /* Ensure all the necessary images have loaded before updating heights */
            $($root).imagesLoaded().always(function () {
                var Section = {
                    dom: {
                        base: $root,
                        spot: $($root).find('article[class*=grid]'),
                        spotGroups: []
                    },
                    set: {
                        height: [],
                        tempHeight: 0,
                        tempClass: null,
                        classRight: null,
                        gridSize: 0,
                        gridCount: 0,
                        groupIndex: 0,
                        blockTypes: ['.image-wrapper', '.article-wrapper h1:first-child', '.article-content', '.button-wrapper'],  /* Create a list of class names to loop through and set the heights */
                        blockTypeIndex: 0
                    },
                    fn: {
                        groupSpots: function () {
                            /* Loop through all spots and save them in groups, matching 12 columns */
                            $.each($dom.spot, function () {
                                /* If the article itself does not have a grid class, find the first child that has */
                                var spot = ($(this).filter('[class*="grid"]')) ? $(this) : $(this).find('[class*="grid"]')[0];

                                /* If grid count === 0, create a new group to save spots into */
                                if ($set.gridCount === 0) {
                                    $dom.spotGroups[$set.groupIndex] = [];
                                }

                                /* Filter out the size of the grid and add to the columns counter */
                                $set.tempClass = spot.attr('class');
                                $set.classRight = $set.tempClass.split('grid_')[1];
                                $set.gridSize = $set.classRight.charAt(0) + $set.classRight.charAt(1);
                                $set.gridCount += parseInt($set.gridSize);

                                /* Add the spot to the group */
                                $dom.spotGroups[$set.groupIndex].push(spot);

                                /* Once the grid counter exceeds 12, start over again and increase the group index */
                                if ($set.gridCount >= 12) {
                                    $set.gridCount = 0;
                                    $set.groupIndex++;
                                }
                            });

                            /* Loop through the spots and check whether they are similar (whether the blocktypes are the same) 
		                     * If they are not, remove the group
		                     */
                            $.each($dom.spotGroups, function (index, group) {
                                if (group.length > 1) {
                                    var blockTypeLength;

                                    /* Check each type of block and see if all spots have the same amount */
                                    $.each($set.blockTypes, function (typeIndex, className) {
                                        blockTypeLength = 0;
                                        $.each(group, function (groupIndex, spot) {
                                            blockTypeLength += spot.find(className).length;
                                        });

                                        if (group.length != blockTypeLength && blockTypeLength != 0) {
                                            delete $dom.spotGroups[index];

                                            return false;
                                        } else {
                                        }
                                    });
                                }
                            });
                        },
                        resizeSpots: function () {
                            $.each($dom.spotGroups, function (index, group) {
                                if (!group) {
                                    return;
                                }

                                /* Reset the settings before looping through the spots */
                                for (var i = 0, j = $set.blockTypes.length; i < j; i++) {
                                    $set.height[i] = 0;
                                }

                                /* Loop through the spots and set the heights, only if there are more than 1 spot */
                                if (group.length > 1) {
                                    $.each(group, function (groupIndex, spot) {

                                        /* Loop through the blockTypes and register the heights */
                                        $.each($set.blockTypes, function (typeIndex, className) {
                                            $set.tempHeight = spot.find(className).height();

                                            if ($set.tempHeight > $set.height[typeIndex]) {
                                                $set.height[typeIndex] = spot.find(className).height();
                                            }
                                        });
                                    });

                                    /* Resize the spots to horizontally align all the block types */
                                    $.each($set.height, function (typeIndex, height) {
                                        if (height > 0) {
                                            $.each(group, function (groupIndex, spot) {
                                                spot.find($set.blockTypes[typeIndex]).height(height);
                                            });
                                        }
                                    });
                                }
                            });
                        }
                    }
                },
		        $dom = Section.dom,
                $set = Section.set,
                $fn = Section.fn;

                /* Start with grouping the spots together */
                $fn.groupSpots();

                /* Check the height of elements of all spot inside each group and set the tallest to all
		         * Include a small timeout to ensure everything is rendered
		          */
                setTimeout(function () {
                    $fn.resizeSpots();
                }, 100);
            });
        //});

    });

})(window, document, jQuery);
